import { useState, useEffect, useMemo } from "react";
import "./UploadInput.css";
import { message, Modal, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const UploadInput = ({
  name,
  allowedFileTypes,
  onChange,
  defaultFile,
  value,
}) => {
  const [image, setImage] = useState();
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  // Convert value to proper fileList format for Ant Design Upload
  const fileList = useMemo(() => {
    if (!value) {
      return [];
    }
    
    // If value is a string (URL), convert to Ant Design file object
    if (typeof value === 'string') {
      return [
        {
          uid: '-1',
          name: 'hotelImage',
          status: 'done',
          url: value,
        },
      ];
    }
    
    // If it's already an array, return as is
    if (Array.isArray(value)) {
      return value;
    }
    
    return [];
  }, [value]);

  useEffect(() => {
    setImage(defaultFile);
  }, [defaultFile]);

  // Update image preview when value (fileList) changes
  useEffect(() => {
    if (value && typeof value === 'string') {
      setImage(value);
    }
  }, [value]);

  const beforeUpload = (file) => {
    setImage(URL.createObjectURL(file));

    if (allowedFileTypes && !allowedFileTypes.includes(file.type)) {
      message.error(
        `You can only upload ${allowedFileTypes.join(",")} file types!`
      );
      return false;
    }
    const isLt4M = file.size / 1024 / 1024 < 4;
    if (!isLt4M) {
      message.error("Image must smaller than 4MB!");
      return false;
    }

    return false;
  };

  const handleChange = (info) => {
    if (info.fileList?.length > 0) {
      setImage(URL.createObjectURL(info.file));
    } else {
      setImage(null);
    }
    if (onChange) {
      onChange(info.fileList);
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  return (
    <>
      <Upload
        fileList={fileList}
        multiple={false}
        name={name}
        listType="picture-card"
        beforeUpload={beforeUpload}
        onChange={handleChange}
        style={{ width: "100%" }}
        onPreview={handlePreview}
        className="single-image-upload"
      >
        {image ? null : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        )}
      </Upload>

      <Modal
        open={previewVisible}
        title="Image Preview"
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  );
};

export default UploadInput;
